export const searchResultColumn = [
  { key: 'id', label: 'Id', sortable: true, sticky: false },
  { key: 'taskId', label: 'Task Id', sortable: true },
  { key: 'invoiceNo', label: 'Invoice No', sortable: true },
  {
    key: 'stripeTransactionId',
    label: 'Stripe Transaction Id',
    sortable: true,
    sticky: false,
  },
  { key: 'date', label: 'Invoice Date', sortable: true, sticky: false },
  { key: 'paymentType', label: 'Payment Type', sortable: true, sticky: false },
  { key: 'amount', label: 'Amount', sortable: true },
  { key: 'status', label: 'Import Status', sortable: true },
  { key: 'actions', label: 'Action', sortable: true },
];

export const contactSearchOptions = [
  {
    key: 'id',
    label: 'Id',
    sortable: true,
    sticky: false,
  },
  {
    key: 'profileId',
    label: 'Profile Id',
    sortable: true,
    sticky: false,
  },
  {
    key: 'name',
    label: 'Name',
    sortable: true,
    sticky: false,
  },
  {
    key: 'address',
    label: 'Address',
    sortable: true,
    sticky: false,
  },
  {
    key: 'houseNumber',
    label: 'House Number',
    sortable: true,
    sticky: false,
  },
  {
    key: 'postCode',
    label: 'Postal Code',
    sortable: true,
    sticky: false,
  },
  {
    key: 'city',
    label: 'City',
    sortable: true,
    sticky: false,
  },
  {
    key: 'iban',
    label: 'IBAN',
    sortable: true,
    sticky: false,
  },
  {
    key: 'email',
    label: 'Email',
    sortable: true,
    sticky: false,
  },
  {
    key: 'phone',
    label: 'Phone',
    sortable: true,
    sticky: false,
  },
  {
    key: 'isClient',
    label: 'Type',
    sortable: true,
    sticky: false,
  },
  { key: 'actions', label: 'Action', sortable: true },
];

export const invoiceResultColumn = [
  { key: 'importStatus', label: 'Status', sortable: true, sticky: false },
  {
    key: 'taskId',
    label: 'Task Id',
    sortable: true,
    sticky: false,
  },
  { key: 'profileId', label: 'Profile Id', sortable: true, sticky: false },
  { key: 'invoiceDate', label: 'Invoice Date', sortable: true, sticky: false },
  { key: 'importDate', label: 'Import Date', sortable: true, sticky: false },
  { key: 'amount', label: 'Amount', sortable: true, sticky: false },
  {
    key: 'eolInvoiceNumber',
    label: 'Eol Invoice Number',
    sortable: true,
    sticky: false,
  },
  {
    key: 'eolContactId',
    label: 'Eol Contact Id',
    sortable: true,
    sticky: false,
  },
  { key: 'actions', label: 'Action', sortable: true },
];
